<template>
<section class="pagination" style="padding-bottom: 20px; padding-left: 0px ;padding-right: 0px;">
<button id="pg-button-prev" type="button" class="pagination__button" @click="onClickPreviousPage" v-if="!isInFirstPage">
  <i class="fa fa-chevron-left"></i>
  </button>
<ul class="pagination__list">

    <li v-for="(page,index) in pages" class="pagination__item" :key="index">
      <button 
        type="button" 
        @click="onClickPage(index)"
        :disabled="page.isDisabled"
        :class="{ 'pgbtn active': isPageActive(index),'pgbtn': !isPageActive(index) }"
        :aria-label="`Go to ${page.date.day}`"
        
      >
       {{ page.date.day }}<br>{{ page.date.mth}}
      </button>
    </li>
    
  </ul>
<button id="pg-button-next" type="button" class="pagination__button"  @click="onClickNextPage" v-if="!isInLastPage">
  <i class="fa fa-chevron-right"></i>
  </button>
  

  <!-- <ul class="pagination__list" id="datePager"> <li class="pagination__item"  v-for="(date,index) in dates" :key="date.day"><button :class="{'pgbtn':current-plus!=index,'pgbtn active':current-plus===index}"  data-time="1659176570000" data-position="0" data-target="#20220730">{{ date.day}}<br>{{ date.mth}}</button></li> </ul> -->

  
</section>
</template>


<script>
export default {
data:()=>({
datepage:[],  
}),
props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 5
    },
    totalPages: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    dates:{
      type:Object
    }
  },
  computed: {
    startPage() {
      if (this.currentPage === 0) {
        return 0;
      }
      if (this.currentPage < this.startPage) { 
        return this.startPage-1;
      }
      if(this.endPage===this.totalPages){
        return this.startPage;
      }
      return this.currentPage-1;

    },
    endPage() {

      return Math.min((this.startPage?this.startPage:0) + this.maxVisibleButtons - 1, this.totalPages);
      
    },
    pages() {
      const range = [];
      for (let i = this.startPage; i <= this.endPage; i+= 1 ) {
      if(this.dates[i]){
              range.push({
                date: this.dates[i] 
              });}
      }

      return range;
    },
    isInFirstPage() {
      return this.currentPage === 0;
    },
    isInLastPage() {
      return this.currentPage+1 === this.totalPages;
    },
  },
  methods: {
    onClickFirstPage() {
      this.$emit('pagechanged', 1);
    },
    onClickPreviousPage() {
      this.$emit('pagechanged', this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit('pagechanged', this.startPage+page);
    },
    onClickNextPage() {
      this.$emit('pagechanged', this.currentPage + 1);

    },
    onClickLastPage() {
      this.$emit('pagechanged', this.totalPages);    
    },
    isPageActive(page) {
      return this.currentPage-this.startPage === page;
    },
  }
 
}
</script>